import React, { Component } from 'react';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import {Button} from 'rmwc/Button';
import { Snackbar } from 'rmwc/Snackbar';
import { Typography } from 'rmwc/Typography';
import { Select } from 'rmwc/Select';
import { Link } from 'react-router-dom'
import { Card } from 'rmwc/Card';
import { TextField} from 'rmwc/TextField';
import * as api from '../../api/api';
import StatusMessage from '../../util/StatusMessage'
import { FormField } from 'rmwc/FormField';
import { ListDivider } from 'rmwc/List';
import { Radio } from 'rmwc/Radio';
import BuzzwordBasedResource from '../learning_resource_user/BuzzwordBasedResource';
import TrackBasedResource from '../learning_resource_user/TrackBasedResource';
import DescriptionBasedResource from '../learning_resource_user/DescriptionBasedResource';

class LearningResourceSearch extends Component {
	constructor(props) {
    	super(props)
    	this.state = {
    		data:{
    			searchType: 'description'
    		}
    	}
    }

    onInputChange = (e) => {
    	let data = Object.assign({}, this.state.data)
    	data.searchType = e.target.value
    	this.setState({data: data})
    }

    handleBackAction = (e) => {
    	e.preventDefault()
        this.props.history.push('/portal/app/user/learning_resources')
    }

    render() {
    	let displayComponent
    	let handleBackAction = this.handleBackAction
    	let userType = 'user'

    	if (this.state.data.searchType === 'tracks') {
    		displayComponent = (
    			<TrackBasedResource userType = {userType} />
    		)
    	}
        else if (this.state.data.searchType === 'description') {
            displayComponent = (
                <DescriptionBasedResource userType = {userType} />
            )
        }
    	else {
    		displayComponent = (
    			<div>
    				<Grid className = "opportunity-list-item">
    					<GridCell span = "12">
    						<Card style={{padding: '20px'}}>
								<GridCell span = "12">
	                            	<Typography use="headline7">Please select an option above to view the classification of search functionality.</Typography>
	                            </GridCell>
	                        </Card>
    					</GridCell>
    				</Grid>
    			</div>
    		)
    	}
    	let searchTypeComponent = (
    		<div>
    			<Grid className="opportunity-list-item-note">
					<GridCell span = "12">
                        <Typography> Search by: </Typography>
                        <Radio
                            name="searchTypeId"
                            value="description"
                            checked={this.state.data.searchType == 'description'}
                            onChange={this.onInputChange}>
                            Keyword
                        </Radio>
		    			<Radio
							name="searchTypeId"
							value="tracks"
							checked={this.state.data.searchType == 'tracks'}
							onChange={this.onInputChange}>
							Subject
					    </Radio>
			    	</GridCell>
			    </Grid>
    		</div>
    	)
    	return (
    		<div>
    			<Grid className="opportunity-list-item">
					<GridCell span = "12">
						<Card style={{padding: '0px'}}>
							<Grid className="opportunity-list-item">
								<GridCell span = "11">
	                            	<Typography use="headline5">Search for Learning Resources</Typography>
	                            </GridCell>
                        		<GridCell span = "1">
                            		<Button raised style={{ width: '100%' }} onClick = {((e) => handleBackAction(e))}>Home</Button>
                        		</GridCell>
                        	</Grid>
                        </Card>
					</GridCell>
				</Grid>
    			{searchTypeComponent}
    			{displayComponent}
    		</div>
    	)
    }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(LearningResourceSearch);


// WEBPACK FOOTER //
// ./src/views/learning_resource_user/LearningResourceSearch.jsx